import { ReactElement, useEffect, useState } from "react";
import "./index.css";
import { IAnswer } from "../../type";
import { Modal } from "../Modal";
import { sanitizeLessonText } from "../../utils/sanitizeLessonText";

interface IProps {
  id?: number;
  title?: string;
  question: string[];
  answer: IAnswer[];
  onClickNextEx: (
    passed: boolean,
    answer: string,
    noSendToServer?: boolean
  ) => void;
}

export function SurveyLesson(props: IProps): ReactElement {
  const [p, setP] = useState(-1); // порядковый номер выбранного ответа. -1 это ответ не выбран
  const [completed, setCompleted] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    const anwers = props.answer.filter((a) => a.passed === false);
    if (anwers.length === 0) return;
    const f = anwers[anwers.length - 1];
    for (let i = 0; i < props.question.length; i++) {
      if (props.question[i] === f.answer) {
        setP(i);
        setCompleted(true);
      }
    }
  }, [props.answer, props.question]);

  const safeTitle = sanitizeLessonText(props.title);

  return (
    <>
      <div className="textConteiner">
        <h2>{safeTitle}</h2>
        <div className="survevyLessonBlockBtn">
          {props.question?.map((a, count) => {
            let cls = "surveyLesson-button";
            const answ = () => {
              setP(count);
            };
            if (p === count) {
              cls = cls + " surveyLesson-button_active";
            }

            return (
              <button className={cls} key={count} onClick={answ}>
                {sanitizeLessonText(a)}
              </button>
            );
          })}
        </div>
      </div>

      <div className="onwardBtnLess">
        {completed === true ? (
          <div
            className="completeButton"
            onClick={() => props.onClickNextEx(false, "", true)}
          >
            Завершить
          </div>
        ) : (
          <>
            <div
              className="mainContentSurveyLesson-skipButton"
              onClick={() => setShowModal(true)}
            >
              Пропустить
            </div>
            {p !== -1 ? (
              <div
                className="mainContentSurveyLesson-sendButton"
                onClick={() => props.onClickNextEx(false, props.question[p])}
              >
                Отправить
              </div>
            ) : (
              ""
            )}
          </>
        )}
        {showModal && (
          <Modal
            onClickLeft={() => {
              setShowModal(false);
            }}
            text={"Пропустишь — и потеряешь дополнительное вознаграждение!"}
            onClickRight={() => {
              props.onClickNextEx(true, "");
            }}
            textBtnLeft={"Вернуться"}
            textBtnRight={"Завершить"}
          />
        )}
      </div>
    </>
  );
}
